import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';

const CONCEPTOS = ['Ventas Comida', 'Ventas Bebidas', 'Ventas Postres', 'Otros Ingresos'];
const CATEGORIAS_GASTO = ['Insumos', 'Limpieza', 'Delivery/Flete', 'Retiro de caja', 'Varios', 'Otro'];
const hoy = new Date().toISOString().split('T')[0];

export default function CajaDiaria() {
  const navigate = useNavigate();
  const [fecha, setFecha] = useState(hoy);
  const [turno, setTurno] = useState('mediodia');
  const [ventas, setVentas] = useState(
    CONCEPTOS.map(c => ({ concepto: c, efectivo: '', mercadopago: '', pedidosya: '', rappi: '', otros: '' }))
  );
  const [gastos, setGastos] = useState([{ descripcion: '', categoria: 'Insumos', monto: '' }]);
  const [guardando, setGuardando] = useState(false);
  const [exito, setExito] = useState(false);

  function updateVenta(i, campo, valor) {
    const nueva = [...ventas];
    nueva[i][campo] = valor;
    setVentas(nueva);
  }

  function updateGasto(i, campo, valor) {
    const nuevos = [...gastos];
    nuevos[i][campo] = valor;
    setGastos(nuevos);
  }

  function agregarGasto() {
    setGastos([...gastos, { descripcion: '', categoria: 'Insumos', monto: '' }]);
  }

  function eliminarGasto(i) {
    setGastos(gastos.filter((_, idx) => idx !== i));
  }

  function calcularTotal(venta) {
    return ['efectivo','mercadopago','pedidosya','rappi','otros']
      .reduce((sum, k) => sum + (parseFloat(venta[k]) || 0), 0);
  }

  function calcularTotalMedio(campo) {
    return ventas.reduce((sum, v) => sum + (parseFloat(v[campo]) || 0), 0);
  }

  function calcularTotalGeneral() {
    return ventas.reduce((sum, v) => sum + calcularTotal(v), 0);
  }

  function calcularTotalGastos() {
    return gastos.reduce((sum, g) => sum + (parseFloat(g.monto) || 0), 0);
  }

  const fmt = n => `$${n.toLocaleString('es-AR', { minimumFractionDigits: 2 })}`;

  async function guardar() {
    setGuardando(true);
    try {
      // Guardar ventas
      const ventasData = ventas
        .filter(v => calcularTotal(v) > 0)
        .map(v => ({
          fecha, turno,
          concepto: v.concepto,
          efectivo: parseFloat(v.efectivo) || 0,
          mercadopago: parseFloat(v.mercadopago) || 0,
          pedidosya: parseFloat(v.pedidosya) || 0,
          rappi: parseFloat(v.rappi) || 0,
          otros: parseFloat(v.otros) || 0,
        }));

      if (ventasData.length > 0) {
        const { error } = await supabase.from('caja_diaria').insert(ventasData);
        if (error) throw error;
      }

      // Guardar gastos
      const gastosData = gastos
        .filter(g => g.descripcion && parseFloat(g.monto) > 0)
        .map(g => ({
          fecha,
          descripcion: g.descripcion,
          categoria: g.categoria,
          monto: parseFloat(g.monto),
        }));

      if (gastosData.length > 0) {
        const { error } = await supabase.from('gastos_diarios').insert(gastosData);
        if (error) throw error;
      }

      setExito(true);
      setTimeout(() => setExito(false), 3000);
    } catch (err) {
      alert('Error al guardar: ' + err.message);
    }
    setGuardando(false);
  }

  return (
    <div style={{ minHeight:'100vh', background:'#F2F3F4' }}>

      {/* Header */}
      <div style={{ background:'#1B2631', padding:'16px 24px', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
        <div>
          <h1 style={{ color:'#fff', margin:0, fontSize:20 }}>📅 Caja Diaria</h1>
          <p style={{ color:'#aaa', margin:'2px 0 0', fontSize:12 }}>Registrá las ventas del día</p>
        </div>
        <button onClick={() => navigate('/dashboard')}
          style={{ background:'transparent', border:'1px solid #555', color:'#aaa', padding:'8px 16px', borderRadius:8, cursor:'pointer' }}>
          ← Volver
        </button>
      </div>

      <div style={{ maxWidth:900, margin:'0 auto', padding:24 }}>

        {exito && (
          <div style={{ background:'#D5F5E3', border:'1px solid #27AE60', borderRadius:8, padding:12, marginBottom:16, color:'#1E8449', fontWeight:'bold', textAlign:'center' }}>
            ✅ ¡Caja guardada correctamente!
          </div>
        )}

        {/* Fecha y Turno */}
        <div style={{ background:'#fff', borderRadius:12, padding:20, marginBottom:16, boxShadow:'0 2px 8px rgba(0,0,0,0.06)', display:'flex', gap:24, alignItems:'center', flexWrap:'wrap' }}>
          <div>
            <label style={lbl}>📆 Fecha</label>
            <input type="date" value={fecha} onChange={e => setFecha(e.target.value)} style={inp} />
          </div>
          <div>
            <label style={lbl}>🕐 Turno</label>
            <div style={{ display:'flex', gap:8, marginTop:6 }}>
              {['mediodia','noche'].map(t => (
                <button key={t} onClick={() => setTurno(t)}
                  style={{
                    padding:'8px 20px', borderRadius:8, border:'none', cursor:'pointer', fontWeight:'bold', fontSize:14,
                    background: turno===t ? (t==='mediodia' ? '#E67E22' : '#1B2631') : '#eee',
                    color: turno===t ? '#fff' : '#666',
                  }}>
                  {t === 'mediodia' ? '🌞 Mediodía' : '🌙 Noche'}
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Tabla de ventas */}
        <div style={{ background:'#fff', borderRadius:12, padding:20, marginBottom:16, boxShadow:'0 2px 8px rgba(0,0,0,0.06)' }}>
          <h2 style={{ margin:'0 0 16px', fontSize:16, color:'#1B2631' }}>
            💰 Ventas — {turno === 'mediodia' ? '🌞 Mediodía' : '🌙 Noche'}
          </h2>
          <div style={{ overflowX:'auto' }}>
            <table style={{ width:'100%', borderCollapse:'collapse', fontSize:13 }}>
              <thead>
                <tr>
                  {['Concepto','Efectivo','MercadoPago','PedidosYa','Rappi','Otros','Total'].map(h => (
                    <th key={h} style={{ background:'#1B2631', color:'#fff', padding:'10px 8px', textAlign:'center', fontWeight:'bold' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {ventas.map((v, i) => (
                  <tr key={i} style={{ background: i%2===0 ? '#F8F9FA' : '#fff' }}>
                    <td style={{ padding:'8px', fontWeight:'bold', color:'#1B2631' }}>{v.concepto}</td>
                    {['efectivo','mercadopago','pedidosya','rappi','otros'].map(campo => (
                      <td key={campo} style={{ padding:'4px' }}>
                        <input
                          type="number"
                          placeholder="0"
                          value={v[campo]}
                          onChange={e => updateVenta(i, campo, e.target.value)}
                          style={{ width:'100%', padding:'6px', border:'1px solid #ddd', borderRadius:6, textAlign:'right', fontSize:13 }}
                        />
                      </td>
                    ))}
                    <td style={{ padding:'8px', textAlign:'right', fontWeight:'bold', color:'#27AE60' }}>
                      {fmt(calcularTotal(v))}
                    </td>
                  </tr>
                ))}
                {/* Fila totales */}
                <tr style={{ background:'#1B2631' }}>
                  <td style={{ padding:'10px 8px', color:'#fff', fontWeight:'bold' }}>TOTAL</td>
                  {['efectivo','mercadopago','pedidosya','rappi','otros'].map(campo => (
                    <td key={campo} style={{ padding:'8px', textAlign:'right', color:'#fff', fontWeight:'bold' }}>
                      {fmt(calcularTotalMedio(campo))}
                    </td>
                  ))}
                  <td style={{ padding:'8px', textAlign:'right', color:'#E67E22', fontWeight:'bold', fontSize:15 }}>
                    {fmt(calcularTotalGeneral())}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* Gastos del día */}
        <div style={{ background:'#fff', borderRadius:12, padding:20, marginBottom:16, boxShadow:'0 2px 8px rgba(0,0,0,0.06)' }}>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:16 }}>
            <h2 style={{ margin:0, fontSize:16, color:'#1B2631' }}>💸 Gastos del Día</h2>
            <button onClick={agregarGasto}
              style={{ background:'#E67E22', color:'#fff', border:'none', borderRadius:8, padding:'8px 16px', cursor:'pointer', fontWeight:'bold' }}>
              + Agregar
            </button>
          </div>
          {gastos.map((g, i) => (
            <div key={i} style={{ display:'flex', gap:8, marginBottom:8, alignItems:'center', flexWrap:'wrap' }}>
              <input placeholder="Descripción" value={g.descripcion} onChange={e => updateGasto(i,'descripcion',e.target.value)}
                style={{ flex:2, ...inp }} />
              <select value={g.categoria} onChange={e => updateGasto(i,'categoria',e.target.value)} style={{ flex:1, ...inp }}>
                {CATEGORIAS_GASTO.map(c => <option key={c}>{c}</option>)}
              </select>
              <input type="number" placeholder="Monto" value={g.monto} onChange={e => updateGasto(i,'monto',e.target.value)}
                style={{ flex:1, ...inp }} />
              <button onClick={() => eliminarGasto(i)}
                style={{ background:'#FADBD8', color:'#C0392B', border:'none', borderRadius:8, padding:'8px 12px', cursor:'pointer', fontWeight:'bold' }}>
                ✕
              </button>
            </div>
          ))}
          <div style={{ textAlign:'right', marginTop:12, fontWeight:'bold', color:'#C0392B', fontSize:15 }}>
            Total gastos: {fmt(calcularTotalGastos())}
          </div>
        </div>

        {/* Balance del día */}
        <div style={{ background:'#1B2631', borderRadius:12, padding:20, marginBottom:24, color:'#fff' }}>
          <h2 style={{ margin:'0 0 12px', fontSize:16 }}>⚖️ Balance del Día</h2>
          <div style={{ display:'flex', gap:16, flexWrap:'wrap' }}>
            {[
              { label:'💰 Ingresos', valor: calcularTotalGeneral(), color:'#27AE60' },
              { label:'💸 Gastos',   valor: calcularTotalGastos(),  color:'#C0392B' },
              { label:'📊 Balance',  valor: calcularTotalGeneral() - calcularTotalGastos(), color:'#E67E22' },
            ].map((item, i) => (
              <div key={i} style={{ flex:1, minWidth:150, background:'rgba(255,255,255,0.08)', borderRadius:8, padding:16, textAlign:'center' }}>
                <div style={{ fontSize:13, color:'#aaa', marginBottom:4 }}>{item.label}</div>
                <div style={{ fontSize:20, fontWeight:'bold', color:item.color }}>{fmt(item.valor)}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Botón guardar */}
        <button onClick={guardar} disabled={guardando}
          style={{ width:'100%', padding:16, background: guardando ? '#aaa' : '#27AE60', color:'#fff', border:'none', borderRadius:12, fontSize:18, fontWeight:'bold', cursor: guardando ? 'not-allowed' : 'pointer' }}>
          {guardando ? 'Guardando...' : '💾 Guardar Caja del Día'}
        </button>

      </div>
    </div>
  );
}

const lbl = { fontSize:12, color:'#888', fontWeight:'bold', display:'block', marginBottom:4 };
const inp = { padding:'8px 10px', border:'1px solid #ddd', borderRadius:8, fontSize:14, outline:'none' };